import { captureException } from '@sentry/react'
import { server } from './config'
import { useToken } from './hooks'

type FetcherResponse<T> = {
  err?: unknown
  status?: number
  data?: T
}

type Headers = {
  'Content-Type': string
  Authorization?: string
}

type Method = 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH'

type FetcherArgs = {
  path: string
  method?: Method
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  body?: any
  auth?: string | null
}

// TODO: replace with jslib fetcher
export const fetcher = async <T>({ ...args }: FetcherArgs) => {
  const retObj: FetcherResponse<T> = {}
  const { path, method, body, auth } = args
  const headers: Headers = {
    'Content-Type': 'application/json',
  }
  if (auth) headers.Authorization = 'Bearer ' + auth
  try {
    const options = {
      method: method || 'GET',
      body: body && JSON.stringify(body),
      headers,
    }
    const res = await fetch(`${server}${path}`, options)

    const result = await res.json()
    if (!res.ok) {
      retObj.err = result as unknown
      retObj.status = res.status
      throw new Error(JSON.stringify(res))
    }
    retObj.data = result
    retObj.status = res.status
  } catch (e) {
    captureException(e)
    console.error(retObj.err || e)
    retObj.err = retObj.err || e
  }
  return retObj
}

export const useFetcher = () => {
  const token = useToken()

  return async <T>({ ...args }: FetcherArgs) =>
    fetcher<T>({ ...args, auth: token })
}
